import { Component, OnInit, Input, AfterViewInit, OnDestroy, OnChanges, ElementRef } from '@angular/core';
import { BaseService } from '../../shared-service/base.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NavbarService } from '../../learner/navbar/navbar.service';

declare var $: any;

@Component({
  selector: 'app-learning-card-list',
  templateUrl: './learning-card-list.component.html',
  styleUrls: ['./learning-card-list.component.css']
})
export class LearningCardListComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() headerLabel: string="";
  @Input() LearningList: Array<any> = [];
  @Input() LearningCard: Object[]|any;
  @Input() CardType: string=""; 
  @Input() learningCount: number =0; 

  headerLabelText: string = "";
  viewAllLabel: string ="";
  FilterBy: string = "0";
  AssignedFilterBy: string = "";
  constructor(public bs: BaseService, private router: Router, private route: ActivatedRoute, private ns: NavbarService,private elRef: ElementRef) {  }
  ngOnInit() {
    var cardListItems = this.elRef.nativeElement.getElementsByClassName("cardListLoader");
    cardListItems[0].setAttribute("src","assets/img/ajax-loader.gif");
    var timer = setInterval(function (cardList, nativeElement) {

      if (nativeElement.getElementsByClassName("owl-item active").length>0) {
        cardList.style.display = "none";
        clearInterval(timer);
      }
    }, 500, cardListItems[0], this.elRef.nativeElement);


    this.route.params.subscribe((param) => {
      console.log('Param: ngOnInit LearningCardListComponent')
      console.log(param)
      this.loadData();
    });

    this.ns.subjectToBeObservedGlobalSearch.subscribe((param1) => {
      console.log('Param: ngOnInit LearningCardListComponent')
      console.log(param1)
      this.loadData();
    });
  }

  loadData() {
    $('.owl-carousel-projects').each(function () {
      $(this).owlCarousel('destroy');
    });

    setTimeout(() => {
      this.InitCarousel();      
      this.headerLabelText = this.bs.getResource(this.headerLabel);
      this.viewAllLabel = this.bs.getResource('rbkey_VwAllLBL');
    }, 500)
  



  }

  ngAfterViewInit() {
    
  }

  ngOnChanges() {
  }

  ngOnDestroy() {
    console.log('Param: ngOnDestroy LearningCardListComponent')

  }

  ViewAll(count: number, Type: string) {
    this.bs.isVwLrng = true;
    this.bs.setCurrentModulePath(this.bs.loadModulePath('tsk_mdl'));
    this.router.navigate([this.bs.getDirectPath('tsk_mdl'), { outlets: { currentTaskList: ['view-all-learning', { time: new Date().getTime(), recordscount: count, StatusType: Type, id: 0, filterBy: this.FilterBy, assignedFilterBy: this.AssignedFilterBy }] } }], { relativeTo: this.route.parent });
  }

  InitCarousel() {
    setTimeout(function () {
      var owl = $('.owl-carousel-projects');
      owl.owlCarousel({
        nav: true,
        loop: false,
        navRewind: false,
        mouseDrag: false,
        margin: 0,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          480: {
            items: 2
          },
          1024: {
            items: 3
          },
          1160: {
            items: 4
          }
        }
      });
    }, 500);
  }

}

